export function VehicleShowcase() {
  const vehicles = [
    {
      image: 'https://public.readdy.ai/ai/img_res/dc852c995a8ce62503b55fabe118abfe.jpg',
      year: '2019',
      make: 'Toyota',
      model: 'RAV4',
      trim: 'XLE AWD',
      price: '$24,995',
      mileage: '62,000',
      features: ['AWD', 'Backup Camera', 'Bluetooth', 'Roof Rack']
    },
    {
      image: 'https://readdy.ai/api/search-image?query=blue%20ford%20f150%20pickup%20truck%20parked%20on%20gravel%20road%20with%20forest%20background%20rugged%20reliable%20work%20truck%20pacific%20northwest%20setting%20professional%20automotive%20photography%20side%20angle%20natural%20lighting%20simple%20background&width=400&height=300&seq=swwa-f150&orientation=landscape',
      year: '2018',
      make: 'Ford',
      model: 'F-150',
      trim: 'XLT 4x4',
      price: '$28,995',
      mileage: '78,000',
      features: ['4x4', 'Tow Package', 'Crew Cab', 'Bed Liner']
    },
    {
      image: 'https://readdy.ai/api/search-image?query=white%20subaru%20outback%20wagon%20parked%20near%20beach%20with%20coastal%20dunes%20background%20adventure%20ready%20vehicle%20pacific%20coast%20scenery%20professional%20automotive%20photography%20three%20quarter%20front%20view%20natural%20daylight%20simple%20background&width=400&height=300&seq=swwa-outback&orientation=landscape',
      year: '2020',
      make: 'Subaru',
      model: 'Outback',
      trim: 'Premium',
      price: '$26,995',
      mileage: '45,000',
      features: ['AWD', 'EyeSight Safety', 'Heated Seats', 'Roof Rails']
    },
    {
      image: 'https://readdy.ai/api/search-image?query=red%20honda%20crv%20suv%20parked%20on%20coastal%20highway%20with%20evergreen%20trees%20background%20reliable%20family%20vehicle%20pacific%20northwest%20setting%20professional%20automotive%20photography%20side%20three%20quarter%20angle%20natural%20lighting%20simple%20background&width=400&height=300&seq=swwa-crv&orientation=landscape',
      year: '2019',
      make: 'Honda',
      model: 'CR-V',
      trim: 'EX AWD',
      price: '$23,995',
      mileage: '58,000',
      features: ['AWD', 'Sunroof', 'Apple CarPlay', 'Lane Keep Assist']
    },
    {
      image: 'https://readdy.ai/api/search-image?query=grey%20chevrolet%20silverado%20pickup%20truck%20parked%20on%20rural%20road%20with%20coastal%20landscape%20background%20powerful%20work%20truck%20pacific%20northwest%20scenery%20professional%20automotive%20photography%20side%20angle%20natural%20daylight%20simple%20background&width=400&height=300&seq=swwa-silverado&orientation=landscape',
      year: '2017',
      make: 'Chevrolet',
      model: 'Silverado 1500',
      trim: 'LT 4WD',
      price: '$27,995',
      mileage: '82,000',
      features: ['4WD', 'Z71 Package', 'Tow Mirrors', 'Running Boards']
    },
    {
      image: 'https://readdy.ai/api/search-image?query=black%20mazda%20cx5%20suv%20parked%20near%20coastal%20town%20with%20ocean%20glimpse%20background%20stylish%20practical%20vehicle%20pacific%20coast%20setting%20professional%20automotive%20photography%20three%20quarter%20front%20view%20natural%20lighting%20simple%20background&width=400&height=300&seq=swwa-cx5&orientation=landscape',
      year: '2020',
      make: 'Mazda',
      model: 'CX-5',
      trim: 'Touring AWD',
      price: '$25,995',
      mileage: '38,000',
      features: ['AWD', 'Leather', 'Bose Audio', 'Power Liftgate']
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            Vehicles Perfect for <span className="text-teal-600">Coastal Washington Living</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            AWD for wet roads. 4x4 for rural routes. Reliable brands that handle salt air and Pacific Northwest winters.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {vehicles.map((vehicle, index) => (
            <div key={index} className="bg-white border border-slate-200 rounded-xl overflow-hidden hover:shadow-xl transition-all group cursor-pointer">
              <div className="relative h-56 overflow-hidden">
                <img 
                  src={vehicle.image}
                  alt={`${vehicle.year} ${vehicle.make} ${vehicle.model}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  width={400}
                  height={224}
                  loading="lazy"
                  decoding="async"
                />
                <div className="absolute top-4 right-4 bg-teal-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                  {vehicle.price}
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-slate-900 mb-2">
                  {vehicle.year} {vehicle.make} {vehicle.model}
                </h3>
                <p className="text-slate-600 mb-4">{vehicle.trim}</p>
                <div className="flex items-center gap-2 text-sm text-slate-500 mb-4">
                  <i className="ri-dashboard-line"></i>
                  <span>{vehicle.mileage} miles</span>
                </div>
                <div className="flex flex-wrap gap-2 mb-4">
                  {vehicle.features.map((feature, idx) => (
                    <span key={idx} className="bg-slate-100 text-slate-700 px-3 py-1 rounded-full text-xs font-medium">
                      {feature}
                    </span>
                  ))}
                </div>
                <a 
                  href="/inventory"
                  className="block w-full text-center bg-teal-600 hover:bg-teal-700 text-white py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
                >
                  View Details
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a 
            href="/inventory" 
            className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-car-line text-xl"></i>
            View Full Inventory
          </a>
        </div>
      </div>
    </section>
  );
}

export default VehicleShowcase;
